import React, { useState, useRef } from 'react';
import { useField } from 'formik';
import styles from "layout/Auth/Auth.module.scss";
import { AttachmentIcon } from "Assets/icons";
import { Button } from "react-bootstrap";
import { useUploadFileMutation } from "store/services/utility";
import LoadingIndicator from "../LoadingIndicator";
import { isArray } from "lodash";
import SingleUploadedFileDetail from "./SingleUploadedFileDetail";
import { Paperclip } from 'react-feather';

const AppFileUploadForPdf = ({
  label,
  acl,
  allowedTypes = [],
  onChange,
  handleRemove,
  preview,
  isMulti = true,
  disableListing = false,
  useButton = true,
  buttonLabel = "",
  buttonVariant = "light",
  buttonSize = "sm",
  ...props
}) => {
  const [uploadFile, { isLoading: isUploading }] = useUploadFileMutation();
  const [field, meta] = useField(props);
  const [fileInputKey, setFileInputKey] = useState(Date.now());
  const fileInputRef = useRef(null); 

  const handleFileChange = async (event) => {
    try {
      const file = event.currentTarget.files[0];
      if (file) {
        if (allowedTypes.length && !allowedTypes.includes(file.type)) {
          alert('File type not allowed.');
          return;
        }

        const response = await uploadFile({ file, acl });
        if (!response?.error) {
          if (typeof onChange === "function") {
            onChange(field.name, response?.data);
          }
          setFileInputKey(Date.now()); // reset file input
        }
      }
    } catch (err) {
      console.error("Error uploading file:", err);
    }
  };

  const triggerFileInput = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  return (
    <>
      <div className="iconWithText position-relative">
        {useButton ? (
          <>
            <input
              key={fileInputKey}
              ref={fileInputRef} // 👈 assigned here
              type="file"
              onChange={handleFileChange}
              style={{ display: 'none' }}
              {...props}
            />
            <Button
              variant={buttonVariant}
              size={buttonSize}
              onClick={triggerFileInput}
              disabled={isUploading}
            >
              {isUploading ? (
                <div className='mt-1'>
                  <LoadingIndicator size={8} />
                </div>
              ) : (
                <>
                  <Paperclip  size={12}/>
                  {/* {buttonLabel} */}
                </>
              )}
            </Button>
          </>
        ) : (
          <>
            <input
              key={fileInputKey}
              type="file"
              onChange={handleFileChange}
              className={`${styles.formControl} form-control`}
              {...props}
            />
            <span className="icn position-absolute" style={{ right: 5 }}>
              <AttachmentIcon />
            </span>
            {isUploading && (
              <span className="icn position-absolute" style={{ right: 25 }}>
                <LoadingIndicator />
              </span>
            )}
          </>
        )}
      </div>

      {meta.touched && meta.error ? (
        <div className="error">{meta.error}</div>
      ) : null}
    </>
  );
};

export default AppFileUploadForPdf;
